import { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { useFeedbacks, useTeam, useUpdateFeedback } from "../hooks/queries/useAdmin";

const useAdminFeedbackFacade = () => {
    const [activeTab, setActiveTab] = useState("bug");
    const { data: feedbacks = [], isLoading: feedbacksLoading } = useFeedbacks();
    const { data: team = [], isLoading: teamLoading } = useTeam();
    const updateFeedback = useUpdateFeedback();

    const { user: currentUser } = useSelector((state) => state.user);
    const currentUserId = currentUser?._id;

    const handleUpdate = async (id, updatePayload) => {
        try {
            await updateFeedback.mutateAsync({ id, updatePayload });
            toast.success("Database Synced");
        } catch (err) {
            toast.error("Update failed.");
        }
    };

    const loading = feedbacksLoading || teamLoading;

    const getSeverityStyling = (severity) => {
        switch (severity?.toLowerCase()) {
            case "critical":
                return "bg-red-50 text-red-700 border-red-200 ring-1 ring-red-600/10";
            case "high":
                return "bg-orange-50 text-orange-700 border-orange-200 ring-1 ring-orange-600/10";
            case "medium":
                return "bg-blue-50 text-blue-700 border-blue-200 ring-1 ring-blue-600/10";
            case "low":
                return "bg-emerald-50 text-emerald-700 border-emerald-200 ring-1 ring-emerald-600/10";
            default:
                return "bg-slate-50 text-slate-600 border-slate-200 ring-1 ring-slate-500/10";
        }
    };

    const filteredData = useMemo(() => {
        return feedbacks.filter((item) => {
            if (activeTab === "mine") return item.assignedTo?._id === currentUserId;
            return item.category === activeTab;
        });
    }, [feedbacks, activeTab, currentUserId]);

    return {
        activeTab,
        setActiveTab,
        feedbacks,
        loading,
        team,
        filteredData,
        currentUserId,
        handleUpdate,
        getSeverityStyling,
    };
};

export default useAdminFeedbackFacade;
